import { render, staticRenderFns } from "./urlMonitorDetails.vue?vue&type=template&id=cf66a470&scoped=true"
import script from "./urlMonitorDetails.vue?vue&type=script&lang=js"
export * from "./urlMonitorDetails.vue?vue&type=script&lang=js"
import style0 from "./urlMonitorDetails.vue?vue&type=style&index=0&id=cf66a470&prod&scoped=true&lang=scss"
import style1 from "./urlMonitorDetails.vue?vue&type=style&index=1&id=cf66a470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf66a470",
  null
  
)

export default component.exports